module.exports = __webpack_public_path__ + "static/media/MIXCAFE_BLACK & WHITE_STICK 2.05291f70.jpg";